import React, { useRef } from 'react';
import S from './Interrupteur.module.scss';

let compteur = 0;

/**
 * Interrupteur marche/arrêt pour les champs qui valent 0 ou 1.
 *
 * Remplace les champs où l'on tapait « 0 » ou « 1 » et les listes déroulantes
 * à deux options. La valeur reçue peut être 1/0, '1'/'0' ou un booléen, telle
 * qu'elle arrive de l'API ou de l'état d'un formulaire ; onChange renvoie
 * toujours 1 ou 0, le format attendu par l'API.
 *
 * Bouton natif avec role="switch" : barre d'espace, touche Entrée et lecteurs
 * d'écran fonctionnent sans code supplémentaire, aria-checked annonçant l'état.
 * type="button" évite qu'il soumette le formulaire qui le contient.
 *
 * @param {object} props
 * @param {string} props.name - nom du champ, renvoyé en second argument de onChange
 * @param {number|string|boolean|null} [props.valeur] - état actuel ; toute valeur autre que 1, '1' ou true vaut « arrêt »
 * @param {(valeur: number, name: string) => void} [props.onChange]
 * @param {string} [props.label] - libellé affiché à côté, cliquable
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 */
const Interrupteur = ({
  name,
  valeur,
  onChange = () => {},
  label = '',
  disabled = false,
  className = '',
}) => {
  // Identifiant unique et stable, pour relier le libellé au bouton même quand
  // un même champ est affiché deux fois sur la page.
  const identifiant = useRef(null);
  if (identifiant.current === null) {
    compteur += 1;
    identifiant.current = `interrupteur-${compteur}`;
  }

  const actif = valeur === true || valeur === 1 || valeur === '1';

  return (
    <div className={[S.interrupteur, className].join(' ')}>
      <button
        type="button"
        role="switch"
        id={identifiant.current}
        name={name}
        aria-checked={actif}
        disabled={disabled}
        className={[S.piste, actif ? S.actif : ''].join(' ')}
        onClick={() => onChange(actif ? 0 : 1, name)}
      >
        <span className={S.curseur} aria-hidden="true" />
      </button>
      {label && (
        <label htmlFor={identifiant.current} className={S.libelle}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Interrupteur;
